import { render, staticRenderFns } from "./InvoiceRelated_Row.vue?vue&type=template&id=db65b89e&"
import script from "./InvoiceRelated_Row.vue?vue&type=script&lang=js&"
export * from "./InvoiceRelated_Row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports